import { Button, Offcanvas } from "react-bootstrap"
import CodeMirror from '@uiw/react-codemirror';
import { useEffect, useRef, useState } from "react";
import { useTheme } from "../../../context/ThemeContext";
import SvgSave from "../../icons/svg/SvgSave";
import { useTranslation } from "react-i18next";
import spinnerTitle from "../../others/spinnerTitle";
import SpinnerBlock from "../../others/SpinnerBlock";
import ESpinner from "../../others/Spinner";
import * as apiSetting from "../../../api/apiSettings";
import { useToast } from "../../../context/ToastContext";
import { extFile2Extensions } from "../../../utils/helpers/codemiror/getExtensions";
import { searchExtension } from "../../../utils/helpers/codemiror/searchExtension";

const OffCanvasCodeEditor = ({show, setShow}) => {
    
    const { t } = useTranslation(['OffCanvasCodeEditor']);
    const { darkTheme } = useTheme();
    const { showToast } = useToast();
    const refCode = useRef();
    const [ value, setValue ] = useState(null);
    const [ isSaving, setIsSaving ] = useState(false);

    const fetchAddition = async () =>{
        const resValue = await apiSetting.getAdditional(show);
        if (resValue===null) return showToast(t('common:messError'), 'danger');
        setValue(resValue);
    }

    const saveAddition = async () =>{
        setIsSaving(true);
        const resSaved = await apiSetting.setAdditional(show, value);
        if (resSaved) showToast(t('codeSaved'), 'success');
            else showToast(t('common:messError'), 'danger');

        setIsSaving(false);
    }

    useEffect(()=>{
        if (show) fetchAddition();
    }, [show])

    
    
    return (
        <Offcanvas 
            placement="bottom"
            className="OffCanvasCodeEditor"
            show={show!==false} 
            keyboard={false}
            onHide={()=>setShow(false)}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>{t('title')} [{show}]</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body> 
                {(value===null) ? (<ESpinner/>)
                :(
                    <>
                        <SpinnerBlock show={isSaving}/>
                        <CodeMirror 
                            ref={refCode}
                            style={{ border: 'none', boxShadow: 'none', height:'calc(100% - 60px)' }}
                            value={value||''}
                            height='100%'                
                            theme={darkTheme ? 'dark' : 'light'}
                            onChange={(value)=>setValue(value)}
                            onCreateEditor={(view) => {
                                view.focus();
                                refCode.current = view;
                            }}
                            extensions={
                                [extFile2Extensions(`.${show}`), searchExtension()]
                            }/>
                     </>
                )}
                
            </Offcanvas.Body>
            <div className="position-absolute p-3 d-flex justify-content-between"
                style={{
                    bottom:'0px',
                    right:'0px',
                    left:'0px',
                    backdropFilter: 'blur(7px)', 
                    zIndex:999,
                    background: 'var(--pc-header-background)'
                }}>
                    <div>
                    </div>
                    <div className="text-end">
                    <Button 
                        disabled={isSaving}
                        className="min100px"
                        onClick={()=>saveAddition()}>
                        {spinnerTitle((<><SvgSave className="me-2 mtop-2"/>{t('common:buttons.save')}</>), isSaving, t('common:buttons.saving'))}
                    </Button>
                    </div>                
            </div>
      </Offcanvas>
    )
}  

export default OffCanvasCodeEditor;